import { record, inventoryId, type Row } from '../ability/context';
import { readInventoryRows } from '../compile/inventory-raw-readers';
import { inventoryField } from '../../shared/array-types';
import { normalizePhpListish } from '../../shared/php-listish';

/** Cache hosts carry instances in these native trees. Catalog and computed definitions
 * are not instance trees; walking them on every equipment/flag click is unnecessary. */
export function cachedInventoryTrees(value: unknown): Row[][] {
  const host = record(value);
  if (!host) return [];
  if (inventoryId(host)) return [[host]];
  return [readInventoryRows(host, 'inventory'), readInventoryRows(host, 'encounter_inventories_arr'),
    ...normalizePhpListish(host.encounter_creatures_arr).map(member => readInventoryRows(record(member), 'inventory'))];
}

/** Borrow only physical instances, including sparse container collections. */
export function* cachedInventoryRows(value: unknown): Generator<Row> {
  function* walk(rows: Row[], depth: number): Generator<Row> {
    if (depth > 24) return;
    for (const row of rows) {
      yield row;
      yield* walk(readInventoryRows(row, 'inventory_in_container'), depth + 1);
    }
  }
  for (const tree of cachedInventoryTrees(value)) yield* walk(tree, 0);
}

/** Resolve a physical instance without walking catalogs or computed definitions. */
export function cachedInventoryRow(value: unknown, id: string): Row | null {
  const wanted = id.toUpperCase();
  for (const row of cachedInventoryRows(value))
    if (String(inventoryField(row, 'inventory_id') ?? '').toUpperCase() === wanted) return row;
  return null;
}
